const SideComponent = ({ side }) => (side);

export { SideComponent };